import React from "react";
import {
  FaBuromobelexperte,
  FaChessQueen,
  FaChessKnight,
  FaSignal,
} from "react-icons/fa";
import { GiMaze } from "react-icons/gi";
import { Link } from "react-router-dom";

type Props = {};

function menu({}: Props) {
  return (
    <nav className="menu">
      <input
        type="checkbox"
        className="menu-open"
        name="menu-open"
        id="menu-open"
      />
      <label className="menu-open-button" htmlFor="menu-open">
        <span className="lines line-1"></span>
        <span className="lines line-2"></span>
        <span className="lines line-3"></span>
      </label>

      <a href="#" className="menu-item blue">
        <FaChessKnight
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </a>
      <Link to="sudoku" className="menu-item green">
        <FaBuromobelexperte
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </Link>
      <Link to="nqueen" className="menu-item red">
        <FaChessQueen
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </Link>
      <a href="#" className="menu-item purple">
        <FaSignal
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </a>
      <a href="#" className="menu-item orange">
        <FaBuromobelexperte
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </a>
      <a href="#" className="menu-item lightblue">
        <GiMaze
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            background: "transparent",
          }}
        />
      </a>
    </nav>
  );
}

export default menu;
